import './assets/css/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@vueuse/head'
import { i18n } from '@/plugins/i18n'
import { initPageTracking } from '@/plugins/pageTracking'

const app = createApp(App)

app.use(createPinia())

Sentry.init({
  app,
  dsn: 'https://a302eaca93493a94b736d5e8b86d87e9@o4508415226413056.ingest.us.sentry.io/4508415229493248',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'], // Capture only error-level console messages
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/holy-bible\.app\/(?:user|auth|paddle|payment)/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(router)
app.use(i18n)
app.use(createHead())
app.mount('#app')

initPageTracking()
